export const TEST_ID = 'collapsibleSection';
